<template>
  <div class="d-flex flex-fill flex-column" style="width: 100%">
    <!-- CURRENT TAGS -->
    <div class="d-flex align-items-center flex-wrap">
      <i class="fas fa-plus-square m-1" @click="toggleAddTag" style="cursor: pointer" ></i>
      <span class="mr-1">Tags:</span>
      <div class="d-flex badge badge-maadi m-1 p-1" v-for="tag in this.existingTags" :key="tag.id">
        {{ tag.name }}
        <div v-if="$store.getters.hasSuperAdministrator" class="ml-2">
          <i class="fas fa-times" style="cursor: pointer" v-on:click="removeTag(tag.id)"></i>
        </div>
      </div>
    </div>
    <!-- INPUT -->
    <div class="d-flex flex-column" v-if="addTagsToggled">
      <div v-if="isLoaded">
          <div v-if="possibleTags" class="d-flex flex-column pt-2" style="width: 100%">
            <div class="d-flex input-group flex-fill">
              <b-form-input id="tagPicker" type="text" v-model="tagToAdd" placeholder="Enter Tag" autocomplete="off"/>
              <!-- only show button if the input results in no possible tags -->
              <b-button v-if="tagToAdd.length > 2 && filteredTags.length === 0" v-on:click="addNewTag">+</b-button>
            </div>
            <div class="d-flex flex-wrap mt-3">
              <div v-for="tag in filteredTags" :key="tag.id" class="d-flex p-2 m-1 badge badge-maadi">
                <div class="flex-fill">{{ tag.name }}&nbsp;<span v-if="tag.type !== null">({{ tag.type }})</span></div>
                  <i class="fas fa-plus" style="cursor: pointer" v-on:click="addTag(tag)"></i>
              </div>
            </div>
          </div>
          <div v-if="possibleTags.length === 0" class="d-flex flex-column mt-3" style="width: 100%">
            <b-spinner type="grow" label="Spinning"></b-spinner>
          </div>
      </div>
      <div class="d-flex justify-content-center align-items-center" v-if="!isLoaded">
        <b-spinner type="grow" label="Spinning"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import TagAPI from '../../api/tags'
export default {
  name: '',
  props: ['organizationID', 'existingTags'],
  data: function () {
    return {
      addTagsToggled: false,
      isLoaded: false,
      tagToAdd: '',
      possibleTags: []
    }
  },
  computed: {
    filteredTags: function () {
      //  start making suggestions after more than two characters have been entered.
      if (this.tagToAdd.length < 2) {
        return
      }
      let filtered = []
      for (let i = 0; i < this.possibleTags.length; i++) {
        const possibleTag = this.possibleTags[i]
        if (possibleTag.name.toLowerCase().indexOf(this.tagToAdd.toLowerCase()) === -1) {
          continue
        }
        if (this.existingTags.filter(x => x.name === possibleTag.name).length > 0) {
          continue
        }
        filtered.push(possibleTag)
      }
      return filtered
    }
  },
  methods: {
    toggleAddTag: function () {
      this.addTagsToggled = !this.addTagsToggled
      if (this.addTagsToggled) {
        this.setPossibleTags()
      }
    },
    setPossibleTags: function () {
      this.possibleTags = []
      TagAPI.getTags()
        .then(response => {
          this.possibleTags = response.data
          this.isLoaded = true
        }).catch()
    },
    addNewTag: function () {
      //  Add tag to list then clear input.
      if (this.existingTags.filter(x => x.name.toLowerCase() === this.tagToAdd.toLowerCase()).length > 0) {
        return
      }
      // Add tag to server
      TagAPI.addTag(this.tagToAdd.toLowerCase()).then(
        response => {
          this.addTag(response.data)
        }
      )
      this.tagToAdd = ''
    },
    addTag: function (tag) {
      this.isLoaded = false
      TagAPI.addTagToOrganization(this.organizationID, tag.id).then(
        result => {
          this.isLoaded = true

          this.emitTagsModified()
        }
      )
      this.tagToAdd = ''
    },
    removeTag: function (tagID) {
      this.tagToAdd = ''
      this.isLoaded = false
      TagAPI.removeTagFromOrganization(this.organizationID, tagID).then(
        result => {
          this.isLoaded = true
          this.emitTagsModified()
        }
      )
    },
    emitTagsModified: function () {
      this.$emit('tagsModified', {organization_id: this.organizationID})
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/organizations/OrganizationTags.vue